(()=>{
  function init(){
    const root=document.querySelector('[data-vpp]');
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    root.classList.add('vpp-js');
    const lifecycle=new AbortController();
    const listen=(element,event,callback)=>element?.addEventListener(event,callback,{signal:lifecycle.signal});
    const preference=matchMedia('(prefers-reduced-motion: reduce)');
    let paused=preference.matches||Boolean(navigator.connection?.saveData);
    const variants=JSON.parse(root.querySelector('[data-vpp-variants]').textContent);
    const variantsById=new Map(variants.map(variant=>[String(variant.id),variant]));
    const money=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:root.dataset.currency||'EUR'});
    const format=value=>money.format(Number(value)/100);
    const selectors=[...root.querySelectorAll('[data-vpp-variant-select]')];
    const rows=[...root.querySelectorAll('[data-vpp-color-row]')];
    const offers=[...root.querySelectorAll('[data-vpp-offer]')];
    const swatches=[...root.querySelectorAll('[data-vpp-swatch]')];
    const form=root.querySelector('.vpp-form');
    const addButton=root.querySelector('[data-vpp-add]');
    const error=root.querySelector('[data-vpp-error]');
    const image=root.querySelector('[data-vpp-main-image]');
    const stage=root.querySelector('.vpp-gallery-stage');
    const thumbs=[...root.querySelectorAll('[data-vpp-thumb]')];
    let activeIndex=Math.max(0,thumbs.findIndex(thumb=>thumb.classList.contains('is-active')));
    let submitting=false;
    function showPhoto(index){
      activeIndex=(index+thumbs.length)%thumbs.length;
      const thumb=thumbs[activeIndex];
      image.src=thumb.dataset.photo;
      image.alt=thumb.dataset.alt;
      stage.classList.toggle('is-cabin',thumb.dataset.cabin==='true');
      thumbs.forEach(item=>{item.classList.toggle('is-active',item===thumb);item.setAttribute('aria-pressed',String(item===thumb));});
      thumb.scrollIntoView({behavior:paused?'instant':'smooth',inline:'nearest',block:'nearest'});
    }
    thumbs.forEach((thumb,index)=>listen(thumb,'click',()=>showPhoto(index)));
    listen(root.querySelector('[data-vpp-gallery-prev]'),'click',()=>showPhoto(activeIndex-1));
    listen(root.querySelector('[data-vpp-gallery-next]'),'click',()=>showPhoto(activeIndex+1));
    const selectedOffer=()=>offers.find(offer=>offer.checked)||offers[0];
    function updateSelection(){
      const offer=selectedOffer();
      const quantity=Number(offer.value);
      offers.forEach(input=>input.closest('.vpp-offer').classList.toggle('is-selected',input===offer));
      rows.forEach((row,index)=>{row.hidden=index>=quantity;selectors[index].disabled=index>=quantity;});
      root.querySelector('[data-vpp-personalize]').dataset.multiple=String(quantity>1);
      root.querySelector('[data-vpp-colors-label]').hidden=quantity===1;
      const variant=variantsById.get(selectors[0].value);
      if(!variant)return;
      offers[0].dataset.price=String(variant.price);
      root.querySelector('[data-vpp-solo-price]').textContent=format(variant.price);
      root.querySelector('[data-vpp-unit-price]').textContent=format(variant.price);
      root.querySelector('[data-vpp-current-color]').textContent=variant.title;
      swatches.forEach(swatch=>{const selected=swatch.dataset.vppSwatch===String(variant.id);swatch.classList.toggle('is-selected',selected);swatch.setAttribute('aria-pressed',String(selected));});
      root.querySelector('[data-vpp-total]').textContent=format(offer.dataset.price);
      root.querySelector('[data-vpp-sticky-price]').textContent=format(offer.dataset.price);
      addButton.disabled=submitting||selectors.slice(0,quantity).some(select=>!variantsById.get(select.value)?.available);
      error.hidden=true;
    }
    function chooseVariant(value,sourceIndex=0){
      const variant=variantsById.get(value);
      if(!variant)return;
      selectors[sourceIndex].value=value;
      const photoIndex=thumbs.findIndex(thumb=>thumb.dataset.mediaId===String(variant.featured_image?.id));
      if(photoIndex>=0)showPhoto(photoIndex);
      if(sourceIndex===0){
        const url=new URL(window.location.href);
        url.searchParams.set('variant',value);
        history.replaceState(null,'',url);
      }
      updateSelection();
    }
    swatches.forEach(swatch=>listen(swatch,'click',()=>chooseVariant(swatch.dataset.vppSwatch)));
    selectors.forEach((select,index)=>listen(select,'change',()=>chooseVariant(select.value,index)));
    offers.forEach(offer=>listen(offer,'change',updateSelection));
    updateSelection();
    listen(form,'submit',async event=>{
      event.preventDefault();
      if(submitting)return;
      updateSelection();
      if(addButton.disabled)return;
      const offer=selectedOffer();
      const quantity=Number(offer.value);
      const grouped=new Map();
      selectors.slice(0,quantity).forEach(select=>grouped.set(select.value,(grouped.get(select.value)||0)+1));
      const items=[...grouped].map(([id,count])=>({id:Number(id),quantity:count}));
      submitting=true;
      addButton.disabled=true;
      addButton.setAttribute('aria-busy','true');
      const text=root.querySelector('[data-vpp-add-text]');
      const previous=text.innerHTML;
      text.textContent=root.dataset.addingLabel;
      try{
        if(window.VoyageCart){
          await window.VoyageCart.add(items,offer.dataset.code);
          submitting=false;text.innerHTML=previous;addButton.removeAttribute('aria-busy');updateSelection();
        }else{
          const response=await fetch(`${root.dataset.rootUrl}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result=await response.json();if(!response.ok||result.status>=400)throw new Error(result.description||root.dataset.errorLabel);
          const code=offer.dataset.code,cartUrl=`${root.dataset.rootUrl}cart`;
          location.assign(code?`${root.dataset.rootUrl}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartUrl)}`:cartUrl);
        }
      }catch(failure){
        error.textContent=failure.message||root.dataset.errorLabel;
        error.hidden=false;
        submitting=false;
        text.innerHTML=previous;
        addButton.disabled=false;
        addButton.removeAttribute('aria-busy');
      }
    });
    const steps=[...root.querySelectorAll('[data-vpp-step]')];
    const detailImage=root.querySelector('[data-vpp-detail-image]');
    steps.forEach(step=>listen(step,'click',()=>{
      steps.forEach(item=>{item.classList.toggle('is-active',item===step);item.setAttribute('aria-pressed',String(item===step));});
      detailImage.src=step.dataset.image;detailImage.alt=step.dataset.alt;
    }));
    const tv=root.querySelector('#vpp-tv');
    const play=root.querySelector('[data-vpp-play]');
    const videoError=root.querySelector('[data-vpp-video-error]');
    listen(play,'click',async()=>{try{tv.controls=true;await tv.play();play.hidden=true;videoError.hidden=true;}catch{play.hidden=true;videoError.hidden=false;}});
    listen(tv,'play',()=>{play.hidden=true;});
    listen(tv,'ended',()=>{play.hidden=false;});
    listen(tv,'error',()=>{videoError.hidden=false;play.hidden=true;});
    const films=[...root.querySelectorAll('[data-vp-film]')];
    const visibleZones=new Set();
    const zones=[...root.querySelectorAll('[data-vpp-cinema],.vp-footer')];
    const wanted=film=>!paused&&!document.hidden&&!film.dataset.failed&&visibleZones.has(film.closest('[data-vpp-cinema],.vp-footer'));
    function syncFilms(){
      films.forEach(film=>{
        if(!wanted(film)){film.pause();return;}
        if(!film.getAttribute('src')){film.muted=true;film.src=film.dataset.vpSrc;film.load();}
        if(film.paused&&!film.dataset.playPending){
          film.dataset.playPending='true';
          const result=film.play();
          if(result)result.then(()=>{if(!wanted(film))film.pause();}).catch(()=>{}).finally(()=>{delete film.dataset.playPending;});
          else delete film.dataset.playPending;
        }
      });
    }
    films.forEach(film=>{
      listen(film,'playing',()=>film.parentElement.classList.add('is-ready'));
      listen(film,'error',()=>{film.dataset.failed='true';film.pause();film.parentElement.classList.remove('is-ready');});
    });
    const motions=[...root.querySelectorAll('[data-vpp-motion],[data-vp-motion]')];
    function updateMotion(){
      root.classList.toggle('vpp-motion-paused',paused);
      motions.forEach(button=>{button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?root.dataset.resumeLabel:root.dataset.pauseLabel);button.querySelector('[data-vpp-motion-icon],[data-vp-motion-icon]').textContent=paused?'▷':'Ⅱ';});
      syncFilms();
    }
    motions.forEach(button=>listen(button,'click',()=>{paused=!paused;updateMotion();}));
    listen(preference,'change',event=>{paused=event.matches;updateMotion();});
    listen(document,'visibilitychange',()=>{syncFilms();if(document.hidden)tv.pause();});
    const observers=[];
    const hero=root.querySelector('.vpp-hero');
    const footer=root.querySelector('.vp-footer');
    const sticky=root.querySelector('[data-vpp-sticky]');
    let heroAbove=false,footerVisible=false;
    function updateSticky(){sticky.hidden=!heroAbove||footerVisible;}
    if('IntersectionObserver' in window){
      const filmObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting)visibleZones.add(entry.target);else visibleZones.delete(entry.target);if(entry.target===footer){footerVisible=entry.isIntersecting;updateSticky();}});syncFilms();},{threshold:0});
      zones.forEach(zone=>filmObserver.observe(zone));observers.push(filmObserver);
      const buyObserver=new IntersectionObserver(entries=>{heroAbove=!entries[0].isIntersecting&&entries[0].boundingClientRect.bottom<0;updateSticky();},{threshold:0});
      buyObserver.observe(hero);observers.push(buyObserver);
      const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');reveal.unobserve(entry.target);}}),{threshold:.07,rootMargin:'0px 0px 25px 0px'});
      root.querySelectorAll('.vpp-reveal').forEach(element=>reveal.observe(element));observers.push(reveal);
      const tvObserver=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)tv.pause();},{threshold:0});tvObserver.observe(tv);observers.push(tvObserver);
    }else{
      zones.forEach(zone=>visibleZones.add(zone));
      root.querySelectorAll('.vpp-reveal').forEach(element=>element.classList.add('is-visible'));
    }
    updateMotion();
    const menu=document.querySelector('#vp-menu');
    const toggle=document.querySelector('[data-vp-menu]');
    if(menu&&toggle){
      listen(toggle,'click',()=>{menu.showModal();toggle.setAttribute('aria-expanded','true');document.documentElement.style.overflow='hidden';});
      listen(menu.querySelector('[data-vp-close]'),'click',()=>menu.close());
      listen(menu,'close',()=>{document.documentElement.style.overflow='';toggle.setAttribute('aria-expanded','false');toggle.focus();});
      menu.querySelectorAll('a').forEach(link=>listen(link,'click',()=>menu.close()));
      listen(menu,'click',event=>{if(event.target===menu){const rect=menu.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right)menu.close();}});
    }
    const lightbox=root.querySelector('[data-vpp-lightbox]');
    const zoom=root.querySelector('[data-vpp-zoom]');
    listen(zoom,'click',()=>{const enlarged=lightbox.querySelector('img');enlarged.src=image.src;enlarged.alt=image.alt;lightbox.showModal();document.documentElement.style.overflow='hidden';});
    listen(root.querySelector('[data-vpp-lightbox-close]'),'click',()=>lightbox.close());
    listen(lightbox,'close',()=>{document.documentElement.style.overflow='';zoom.focus();});
    listen(lightbox,'click',event=>{if(event.target===lightbox){const rect=lightbox.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)lightbox.close();}});
    document.querySelectorAll('a[href^="#vpp-"]').forEach(link=>listen(link,'click',event=>{const target=document.querySelector(link.getAttribute('href'));if(!target)return;event.preventDefault();target.scrollIntoView({behavior:paused?'instant':'smooth',block:'start'});history.replaceState(null,'',link.getAttribute('href'));}));
    listen(document,'shopify:section:unload',event=>{if(!event.target.contains(root))return;observers.forEach(observer=>observer.disconnect());films.forEach(film=>film.pause());tv.pause();lifecycle.abort();});
    listen(window,'pageshow',event=>{if(event.persisted&&submitting)window.location.reload();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
